<div class="dashboard-body">
  <div class="row col-md-12 header-row">
    <div
      class="col-md-2 col-sm-6 col-xs-6 pull-left"
      *ngIf="!selectedSchool"
    ></div>
    <div
      class="col-md-2 col-sm-8 col-xs-10 schools-dropdown pull-left"
      *ngIf="schoolsForDropdown"
    >
      <p class="dropdown-header">School</p>
      <ng-select
        data-id="OurStudents.Schools"
        #studentSchoolsDropdown
        [clearable]="false"
        [disabled]="loadingStudentData"
        [items]="schoolsForDropdown"
        [(ngModel)]="selectedSchool"
        [searchable]="true"
        bindLabel="text"
        placeholder="Search schools"
        (change)="selected($event)"
        (close)="removeFocusFromDropdown()"
        class="generic-dropdown"
        *ngIf="schoolsForDropdown.length > 1"
      >
      </ng-select>
      <p class="school-label" *ngIf="schoolsForDropdown.length == 1">
        {{ selectedSchool.text }}
      </p>
    </div>
    <div
      class="col-md-2 col-sm-8 col-xs-10 schools-dropdown pull-left"
      data-cy="demographicdropdown"
    >
      <div class="dropdown-header-p-div">
        <p class="dropdown-header">Demographics</p>
      </div>
      <checkbox-multiselect
        data-id="OurStudents.Demographics"
        #studentFiltersDropdown
        class="demographic-multi-select"
        [filterDropdown]="demographicsForDropdown"
        [groupBy]="'field'"
        [placeholder]="'Search demographics'"
        [selectedFilterVals]="selectedDemoFilterVals"
        [buttonText]="'All My Students (no filter)'"
        [categoryAttribute]="'field'"
        [itemAttribute]="'subfield.name'"
        [numItemsShown]="3"
        [searchable]="true"
        (filtersSelectedEvent)="filterByDemographics($event)"
        (unselectAllFiltersEvent)="unselectAllDemographicFilters()"
        (clearItemEvent)="clearSingleDemographicFilter($event)"
      ></checkbox-multiselect>
    </div>
    <div
      class="col-md-2 col-sm-8 col-xs-10 schools-dropdown pull-left"
      *ngIf="selectedSchool && selectedSchool != 'none'"
    >
      <p class="dropdown-header">
        {{ userInfo.role != "teacher" ? "Teacher/Section" : "Section" }}
      </p>
      <ng-select
        data-id="OurStudents.TeacherSections"
        [items]="teachersAndSectionsForDropdown"
        groupBy="group"
        bindLabel="text"
        bindValue="id"
        [disabled]="loadingStudentData"
        placeholder="Search {{
          userInfo.role != 'teacher' ? 'teachers or sections' : 'sections'
        }}"
        (change)="filterByTeacherOrSection($event)"
        [(ngModel)]="selectedTeacherOrSectionId"
        [clearable]="false"
        [searchable]="true"
        (close)="removeFocusFromDropdown()"
        class="generic-dropdown"
      >
        <ng-template ng-header-tmp>
          <button
            (click)="clearTeacherAndSectionFilter()"
            class="btn btn-sm clear-filter-btn"
          >
            All my students (no filter)
          </button>
        </ng-template>
      </ng-select>
    </div>
    <div
      class="col-md-2 col-sm-8 col-xs-10 schools-dropdown pull-left"
      *ngIf="
        (userViewsForDropdown && userViewsForDropdown.length > 0) ||
        (groupsForDropdown && groupsForDropdown.length > 0)
      "
    >
      <div class="dropdown-header-and-image">
        <div class="dropdown-header-p-div">
          <p class="dropdown-header">My Lists</p>
        </div>
        <div class="dropdown-header-image">
          <img
            data-id="OurStudents.SettingsCog"
            [src]="'../../assets/images/cog_active.svg'"
            (click)="openListSettingsModal()"
            class="dropdown-image"
            alt="Open view settings"
          />
        </div>
      </div>
      <ng-select
        data-id="OurStudents.Lists"
        #listsDropdown
        [items]="listsForDropdown"
        bindLabel="text"
        groupBy="list"
        [disabled]="loadingStudentData"
        [(ngModel)]="selectedListItem"
        placeholder="- Select list -"
        (change)="selectListItemFromDropdown()"
        [clearable]="false"
        [searchable]="false"
        (close)="removeFocusFromDropdown()"
        class="lists-dropdown"
        *ngIf="listsForDropdown && listsForDropdown.length > 1"
      >
      </ng-select>
    </div>
    <div class="col-md-4 col-sm-8 col-xs-10 view-change-buttons pull-left">
      <div
        class="pull-left change-button"
        *ngIf="
          hasFilteredOrSorted() && differentFromSavedView() && !selectedGroup
        "
      >
        <button
          mat-raised-button
          (click)="saveView()"
          color="primary"
          class="save-view-btn"
        >
          SAVE VIEW
        </button>
      </div>
      <div
        class="pull-left change-button"
        *ngIf="selectedGroup || hasFilteredOrSorted() || hasTopLevelFilters()"
      >
        <button
          mat-raised-button
          (click)="clearAll()"
          color="primary"
          class="clear-all-btn"
        >
          CLEAR ALL
        </button>
      </div>
      <div
        class="pull-left change-button"
        *ngIf="selectedGroup || selectedView"
      >
        <button
          mat-raised-button
          *ngIf="selectedGroup"
          (click)="openListSettingsModal('group', selectedGroup)"
          color="primary"
          class="group-settings-btn"
        >
          <ng-container *ngIf="!selectedGroup.isSharedWithMe">
            CHANGE GROUP SETTINGS
          </ng-container>
          <ng-container *ngIf="selectedGroup.isSharedWithMe">
            SEE GROUP DETAIL
          </ng-container>
        </button>
        <button
          mat-raised-button
          *ngIf="selectedView"
          (click)="openListSettingsModal('view', selectedView)"
          color="primary"
          class="view-settings-btn"
        >
          <ng-container *ngIf="!selectedView.isSharedWithMe">
            CHANGE VIEW SETTINGS
          </ng-container>
          <ng-container *ngIf="selectedView.isSharedWithMe">
            SEE VIEW DETAIL
          </ng-container>
        </button>
      </div>
      <div class="pull-left">
        <button
          data-id="OurStudents.Export"
          [disabled]="exportingStudentData"
          (click)="openExportToCSVModal()"
          color="primary"
          class="export-btn"
        >
          <img [src]="'../../assets/images/export.svg'" class="export-img" />
          EXPORT
        </button>
        <div class="pull-right" *ngIf="exportingStudentData">
          <mat-progress-spinner
            class="export-loading-spinner"
            [diameter]="20"
            [mode]="'indeterminate'"
          >
          </mat-progress-spinner>
        </div>
        <ng-container *ngIf="!selectedGroup && !selectedView">
          <div class="export_button_spacer">&nbsp;</div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row col-md-12 table-row">
    <student-comp-table
      [panels]="panels"
      [columns]="columns"
      [districtMetrics]="districtMetrics"
      [schoolOverall]="schoolOverall"
      [school]="school"
      [studentState]="studentState | async"
      [sortsAndFilters]="sortsAndFilters"
      [schools]="schools"
      [selectedAll]="selectedAll"
      [hasStudentSelected]="hasStudentSelected"
      [groupCriteria]="selectedGroup?.efficacyCriteria"
      [groupStatusSort]="groupStatusSort"
      [groupStatusFilters]="groupStatusFilters"
      (changePage)="changePage($event)"
      (sortsFiltersSelected)="sortsFiltersSelected($event)"
      (studentSelected)="studentSelected($event)"
      (selectAllChange)="selectAllChange($event)"
      (addGroupClicked)="addGroup()"
      (addStudentsToGroupClicked)="addStudentsToGroup()"
      (removeStudentsFromGroupClicked)="removeStudentsFromGroup()"
      #studentCompTable
    ></student-comp-table>
  </div>
</div>
